import { Component, type OnInit } from '@angular/core'
import { Store } from '@ngrx/store'
import { AppOverviewDialogService } from '@tokeet-frontend/billing'
import { LoadActivePlans } from '@tv3/store/plan/plan.actions'
import { ProductsForPlan } from '@tv3/store/plan/plan.model'

@Component({
  selector: 'app-unlock-rental-review-insights',
  templateUrl: './unlock-rental-review-insights.component.html',
  styleUrls: ['./unlock-rental-review-insights.component.scss'],
})
export class UnlockRentalReviewInsightsComponent implements OnInit {
  constructor(private store: Store<any>, private appOverview: AppOverviewDialogService) {}

  ngOnInit(): void {}

  onEnableAI() {
    this.appOverview
      .open(ProductsForPlan.TokeetAI)
      .afterClosed()
      .subscribe((result) => {
        this.store.dispatch(LoadActivePlans({}))
      })
  }
}
